// src/App.jsx
import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import HomePage from "./Pages/Home/HomePage";
import AboutPage from "./Pages/About/AboutUs";
import ServicesDetail from "./Components/Services/ServicesDetails";
import PracticeAreas from "../src/Pages/PracticeAreas/PracticeAreas";
import OurTeam from "./Pages/OurTeam/OurTeam";
import ContactUS from "./Pages/ContactUS/ConatctUS";
import Blogs from "./Pages/Blog/Blog";
import BlogDetails from "./Components/Blog/BlogDetails";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route  path="/about-us" element={<AboutPage/>}/>
        <Route path="/services/:serviceId" element={<ServicesDetail />} />
        <Route path="/services" element={<PracticeAreas/>}/>
        <Route path="/our-team" element={<OurTeam/>}/>
        <Route path="/contact-us" element={<ContactUS/>}/>
        <Route path="/Blogs" element={<Blogs/>}/>
        <Route path="/blogs/:blogId" element={<BlogDetails />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
